import React, {useEffect, useState} from "react";
import Select from "react-select";
import axios from 'axios';
import apiUrl from "../../../shared/config"; // Assuming apiUrl is the base URL

export default function GameStyleInput({currentSelection, onUpdate, useDefaultValue = true, gameStylesArr}) {
    const [options, setOptions] = useState([{value: -1, label: "All"}]);
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState({value: -1, label: "loading...", color: '#808080' })

    useEffect(() => {
        if (gameStylesArr) {
            const newOptions = gameStylesArr.map((item) => ({
                value: item.game_style_id,
                label: item.game_style_name
            }));
            // Prepend "All" to the fetched options
            setOptions([...newOptions, {value: -1, label: "All"}]);
            setLoading(false);
        } else {
            axios.get(apiUrl + "Games/getGameStyles").then((response) => {
                const newOptions = response.data.map((item) => ({
                    value: item.game_style_id,
                    label: item.game_style_name
                }));
                // Prepend "All" to the fetched options
                setOptions([...newOptions, {value: -1, label: "All"}]);
                setLoading(false);
            }).catch((error) => {
                console.error("Error fetching game styles:", error);
                setLoading(false);
            });
        }
    }, [gameStylesArr]);

    useEffect(() => {
        const val = options ? options.find(option => option.value === currentSelection) : {value: -1, label: "loading..."};
        setValue(val);
    }, [currentSelection, options]);

    return (
        <span key="orderBySelector" style={{marginLeft: 5, width: '100%', maxWidth: 300, zIndex: 90}}>
            <Select
                options={options}
                value={value} // Match current selection or default to null
                closeMenuOnSelect={true}
                placeholder="Choose a game style"
                onChange={(selectedOption) => {
                    onUpdate(selectedOption.value);
                }}
                getOptionLabel={option => (
                    <div style={{color: option.color ? option.color : '#000000'}}>
                        {option.label}
                    </div>
                )}
                isLoading={loading} // To show a loading spinner while options are being fetched
            />
        </span>
    );
}